import { apiPost } from '@/lib/http/client';

export async function completeHubspotSetup(
  orgId: number | string,
  backfill: boolean
): Promise<{ success: boolean }> {
  return apiPost<{ success: boolean }>(
    `/api/orgs/${orgId}/hubspot/setup-complete/`,
    { backfill }
  );
}
